// extracted by mini-css-extract-plugin
export var root = "SocialLinks-module--root--FGKFm";
export var link = "SocialLinks-module--link--183m0";
export var horizontal = "SocialLinks-module--horizontal--3uEQv";